<template>
    <div class="projects-container">
        <div class="project-cards-wrapper">
            <div v-for="(project, i) in projects" class="project-card">
                <div class="card-container">
                    <div class="project-info">
                        <div class="project-name"> {{ project.gameName }}</div>
                        <div class="project-company">
                            Due: {{ formatEndTime(project.endTime) }} 
                        </div>
                    </div>
                    <img v-if="project.img != ''" class="project-img" :src="project.img" />
                    <div class="project-buttons">
                        <b-button class="project-button-details" v-on:click="viewDetails(project.gameId, project.gameName, project.img, project.gameDescription)">
                            Start
                            <span v-if="getTotalIncompleteCount(project.gameId) > 0"
                                class="status start-100 translate-middle badge rounded-pill badge-danger">
                                {{ getTotalIncompleteCount(project.gameId) }}
                            </span>
                        </b-button>
                        <b-button class="project-button-survey" v-on:click="showDetailsPopup(project.gameName, project.gameDescription, project.img)">
                            Details 
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Details Popup Modal -->
                <div v-if="detailsPopupVisible" class="popup-overlay" @click="closeDetailsPopup">
            <div class="popup-content" @click.stop>
                <button class="btn-close-circle--dark" @click="closeDetailsPopup">×</button>
                <div class="popup-body">
                    <img v-if="selectedProject.img && selectedProject.img !== ''" 
                        class="popup-img" 
                        :src="selectedProject.img" 
                        alt="Project Image" />
                    <div class="popup-text">
                        <h3 class="popup-title">{{ selectedProject.name }}</h3>
                        <p class="popup-description">{{ selectedProject.description }}</p>
                        <div class="popup-meta">
                            <div class="popup-tags">
                                <span class="popup-tag" v-for="tag in selectedProject.tags" :key="tag">{{ tag }}</span>
                            </div>
                            <div class="popup-meta-col">
                                <span class="popup-meta-item">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                                    {{ selectedProject.playtestTime }}
                                </span>
                                <span class="popup-meta-item">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                                    {{ selectedProject.platform }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Response from '../../Firestore/Response';
import GameTesting from '../../Firestore/GameTesting';

export default {
    name: "ProjectCardsTester",
    props: {
        projects: Array
    },
    data() {
        return {
            userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,  // 0: Tester, 1: Company, 2: Admin
            numIncompleteResponses: {},
            numIncompletePlaytestPeriods: {},
            viewDetailsPopup: false,
            detailsPopupVisible: false,
            selectedProject: {
                name: '',
                description: '',
                img: '',
                tags: ['Tag 1', 'Tag 2', 'Tag 3'], 
                playtestTime: '10-15 min', 
                platform: 'Web build' 
            }
        }
    },
    async mounted() {
        this.userType = parseInt(window.localStorage.getItem("userType"));
        await this.projects.forEach(project => {
            Response.getIncompleteResponsesByTesterProject(window.localStorage.getItem('userId'), project.gameId)
                .then(res => {
                    this.$set(this.numIncompleteResponses, project.gameId, res.data.length);
                })
            GameTesting.getIncompletePlaytesterSessions(project.gameId, window.localStorage.getItem('userId'))
                .then(res => {
                    this.$set(this.numIncompletePlaytestPeriods, project.gameId, res.count);
                })
        })
    },
    methods: {
        getTotalIncompleteCount(gameId) {
            const playtestCount = this.numIncompletePlaytestPeriods[gameId] || 0;
            const surveyCount = this.numIncompleteResponses[gameId] || 0;
            return playtestCount + surveyCount;
        },
        formatEndTime(endTime) {
            if (!endTime) return '--';
            const date = new Date(endTime);
            return date.toLocaleString('en-US', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            });
        },
        goToSurveys(gameId, gameName) {
            window.localStorage.setItem('gameId', gameId);
            window.localStorage.setItem('gameName', gameName)
            // Go to survey section
            this.$router.push({
                name: 'project-surveys'
            })
        },
        closeModal() {
            this.showProfileModal = false;
        },
        viewDetails(gameId, gameName, gameImg, gameDescription) {
            window.localStorage.setItem('gameId', gameId);
            window.localStorage.setItem('gameName', gameName);
            window.localStorage.setItem('gameImg', gameImg);
            this.$emit('open');
        },
        showDetailsPopup(gameName, gameDescription, gameImg) {
            console.log('Project details:', { gameName, gameDescription, gameImg });
            this.selectedProject.name = gameName;
            this.selectedProject.description = gameDescription || 'No description available.';
            this.selectedProject.img = gameImg;
            this.detailsPopupVisible = true;
        },
        closeDetailsPopup() {
            this.detailsPopupVisible = false;
        }
    },
}
</script>

<style scoped>
.projects-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
}

.project-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
}

.project-card {
    background-color: white;
    border-radius: 12px;
    margin: 1rem;
    border: 1px solid #eaeaea;
    transition: box-shadow 0.2s;
    width: 250px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Increase bottom padding specifically */
    padding: 2px 20px 30px 20px; 
    position: relative;
    /* This ensures cards in a row stay the same height if one has more text */
    display: flex;
    flex-direction: column;
}

.project-card:hover {
    box-shadow: 0 4px 8px rgba(255, 142, 77, 0.612);
}

.project-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    margin-top: 10px;
}

.card-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
    text-align: left;
    height: 100%; /* Fill the card height */
    justify-content: space-between; /* Pushes info to top and buttons to bottom */
}

.project-info {
    width: 100%; 
}

.project-name {
    color: #333;
    font-weight: bold;
    font-size: 1.2rem;
    margin-top: 10px;
}

.project-company {
    color: #888;
    font-style: italic;
}

.project-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    width: 100%;
    gap: 15px; /* Added gap for more space between buttons */
}

.project-button-survey {
    background: #FF7222;
    border: 0;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    color: white;
    font-size: 0.9rem;
    flex: 1; /* Added to make buttons equal width */
}

.project-button-survey:hover {
    background: #ff8e4d;
}

.project-button-details {
    position: relative;
    background: #FF7222;
    border: 0;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    color: white;
    font-size: 0.9rem;
    flex: 1; /* Added to make buttons equal width */
}

.project-button-details:hover {
    background: #ff8e4d;
}

/* Shows the status of the user on the project */
.status {
    position: absolute;
    top: 0px;
    background-color: #ff4d4d !important;
    border: 1px solid white !important;
}

.notif-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #ff4d4d;
    color: white;
    font-size: 0.8rem;
    border-radius: 50%;
    padding: 0.25rem 0.5rem;
    border: 2px solid white;
}

.survey-badge {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: pink;
    color: #ff0066;
    border-radius: 12px;
    padding: 0.2rem 0.5rem;
    font-size: 0.8rem;
    text-transform: uppercase;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    max-width: 500px;
    width: 90%;
    height: 300px;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
}

.popup-body {
    display: flex;
    gap: 1rem;
    align-items: stretch;
    flex: 1;
    min-height: 0;
}

.popup-img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    flex-shrink: 0;
    align-self: center;
}

.popup-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}


.popup-title {
    color: #333;
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    margin-top: 0;
}

.popup-tags { 
    display: flex; 
    flex-wrap: wrap; 
    gap: 6px; 
}

.popup-tag { 
    background: #eef2ff; color: #3730a3; 
    font-size: 12px; 
    padding: 4px 10px; 
    border-radius: 6px; 
}
.popup-meta {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    font-size: 13px;
    color: #6b7280;
}

.popup-meta-col {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.popup-meta-item { 
    display: flex; 
    align-items: center; 
    gap: 4px; 
}

.popup-description {
    color: #666;
    line-height: 1.6;
    margin: 0;
    height: 100px;
    overflow-y: auto;
}

@media only screen and (max-width: 1200px) {
    .project-card {
        width: calc(50% - 1rem);
    }
}

@media only screen and (max-width: 700px) {
    .project-card {
        width: 100%;
    }
    
    .popup-content {
        width: 95%;
        padding: 1.5rem;
    }
    
    .popup-body {
        flex-direction: column;
        text-align: center;
    }
    
    .popup-img {
        width: 80px;
        height: 80px;
        align-self: center;
    }
    
    .popup-title {
        font-size: 1.3rem;
    }
    
    .project-buttons {
        gap: 10px; /* Slightly smaller gap on mobile */
    }
}
</style>


// WEBPACK FOOTER //
// src/components/game-dashboard/ProjectCardsTester.vue